function TitleFieldComponent({ title }) {

  return (
    <h2>{title}</h2>
  )
}

export default TitleFieldComponent;